import {
  PRIORIDAD_INCIDENCIA_CHOICE,
  gridSizeMdLg12,
  gridSizeMdLg6,
  useLoaders,
} from '@/shared';
import { useFetchTiposIncidencias } from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTextArea,
  CustomTextField,
  TabTextLabel,
} from '@/shared/components/ui';
import TimeClockComponente from '@/shared/components/ui/TimeClock/TimeClockComponente';
import { TipoIncidencia } from '@/shared/interfaces';

export type OTInstalacionTecnicoCorporativoFormTabProps = {
  form: any;
  errors: any;
  shrink: boolean;
  onlyView?: boolean;
};

const OTInstalacionTecnicoCorporativoFormTab: React.FC<
  OTInstalacionTecnicoCorporativoFormTabProps
> = ({ form, errors, shrink, onlyView = false }) => {
  ///* form ---------------
  // const watchedHora = form.watch('hora_instalacion');

  ///* fetch data ---------------
  const {
    data: tiposIncidenciaPaging,
    isLoading: isLoadingTiposIncidenciaPaging,
    isRefetching: isRefetchingTiposIncidenciaPaging,
  } = useFetchTiposIncidencias({
    page_size: 100,
  });

  useLoaders(
    isLoadingTiposIncidenciaPaging || isRefetchingTiposIncidenciaPaging
  );

  if (isLoadingTiposIncidenciaPaging || isRefetchingTiposIncidenciaPaging)
    return null;

  return (
    <>
      {/* ================ Datos generales ================ */}
      <TabTextLabel text="Datos generales" pb="24px" pt="12px" />
      <>
        <CustomTextField
          name="user_create"
          label="Nombre de Vendedor"
          control={form.control}
          defaultValue={form.getValues()?.user_create || ''}
          error={errors?.user_create}
          helperText={errors?.user_create?.message || ''}
          disabled
        />
        <CustomTextField
          name="canal_venta_create"
          label="Canal de Venta"
          control={form.control}
          defaultValue={form.getValues()?.canal_venta_create || ''}
          error={errors?.canal_venta_create}
          helperText={errors?.canal_venta_create || ''}
          disabled
        />

        <CustomTextField
          name="tecnico_responsable"
          label="tecnico_responsable"
          control={form.control}
          defaultValue={form.getValues()?.tecnico_responsable || ''}
          error={errors?.tecnico_responsable}
          helperText={errors?.tecnico_responsable?.message || ''}
          disabled
        />
        

        <CustomTextField
          label="Fecha de Instalación"
          name="fecha_instalacion"
          control={form.control}
          defaultValue={form.getValues()?.fecha_instalacion || ''}
          error={errors?.fecha_instalacion}
          helperText={errors?.fecha_instalacion?.message}
          shrink={shrink}
          size={gridSizeMdLg12}
          disabled
        />

        <CustomTextField
          name="tipo_enlace"
          label="Tipo enlace"
          control={form.control}
          defaultValue={form.getValues().tipo_enlace || ''}
          error={errors.tipo_enlace}
          helperText={errors.tipo_enlace?.message || ''}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />

        <CustomTextField
          name="tipo_plan"
          label="Tipo plan"
          control={form.control}
          defaultValue={form.getValues().tipo_plan || ''}
          error={errors.tipo_plan}
          helperText={errors.tipo_plan?.message || ''}
          disabled
          shrink={shrink}
          size={gridSizeMdLg6}
        />

        <CustomTextField
          name="tipo_servicio"
          label="Tipo servicio"
          control={form.control}
          defaultValue={form.getValues().tipo_servicio || ''}
          error={errors.tipo_servicio}
          helperText={errors.tipo_servicio?.message || ''}
          disabled
          shrink={shrink}
          size={gridSizeMdLg6}
        />

        <CustomTextField
          name="valor_instalacion_total"
          label="Valor de Instalación"
          control={form.control}
          defaultValue={form.getValues().valor_instalacion_total || ''}
          error={errors.valor_instalacion_total}
          helperText={errors.valor_instalacion_total?.message || ''}
          startAdornment={"$"}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
      </>

      {/* ================ INCIDENCIAS ================ */}
      <TabTextLabel text="Incidencias" pt="54px" pb="12px" />
      <>
        <CustomAutocomplete<TipoIncidencia>
          label="Tipo de Incidencia"
          name="incidencia"
          // options
          options={tiposIncidenciaPaging?.data.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().incidencia || ''}
          isLoadingData={isLoadingTiposIncidenciaPaging}
          // validation
          control={form.control}
          error={errors.incidencia}
          helperText={errors.incidencia?.message}
          size={gridSizeMdLg6}
          required={false}
          onChangeValue={() => {
            form.setValue('prioridad_incidencia', '');
            form.setValue('observacion_tecnico', '');
          }}
          disabled={onlyView}
        />
        <CustomAutocompleteArrString
          label="Prioridad de la Incidencia"
          name="prioridad_incidencia"
          control={form.control}
          defaultValue={form.getValues('prioridad_incidencia')}
          options={PRIORIDAD_INCIDENCIA_CHOICE}
          isLoadingData={false}
          error={errors.prioridad_incidencia}
          helperText={errors.prioridad_incidencia?.message}
          size={gridSizeMdLg6}
          disableClearable
          required={false}
          disabled={onlyView}
        />
        <CustomTextArea
          label="Observación Técnico"
          name="observacion_tecnico"
          control={form.control}
          defaultValue={form.getValues('observacion_tecnico') || ''}
          error={errors.observacion_tecnico}
          helperText={errors.observacion_tecnico?.message}
          required={false}
          disabled={onlyView}
        />
      </>

      {/* ================ HORA INICIO/FIN (Activacion/PyL) ================ */}
      <TabTextLabel text="HORA DE INICIO/FINALIZACIÓN" pt="54px" pb="12px" />

      <TimeClockComponente
        size={gridSizeMdLg6}
        control={form.control}
        error={errors.hora_inicio}
        label='Hora de inicio'
        name='hora_inicio'
        helperText={errors?.hora_inicio?.message}
        enableDateTypeResult={true}
      />
      <TimeClockComponente
        size={gridSizeMdLg6}
        control={form.control}
        error={errors.hora_fin}
        label='Hora de fin'
        name='hora_fin'
        helperText={errors?.hora_fin?.message}
        enableDateTypeResult={true}
      />
    </>
  );
};

export default OTInstalacionTecnicoCorporativoFormTab;
